'use strict';

/**
 * Represents the client-side constants used in the application.
 */ /**
 * Retrieves the client constants for the application.
 * @returns An object containing the public GraphQL endpoint.
 * @throws {Error} If the NEXT_PUBLIC_GRAPHQL_ENDPOINT cannot be found.
 */ function getClientConstants(overrides = {}) {
    var _overrides_PUBLIC_GRAPHQL_ENDPOINT, _ref;
    let PUBLIC_GRAPHQL_ENDPOINT = (_ref = (_overrides_PUBLIC_GRAPHQL_ENDPOINT = overrides.PUBLIC_GRAPHQL_ENDPOINT) != null ? _overrides_PUBLIC_GRAPHQL_ENDPOINT : process.env.NEXT_PUBLIC_GRAPHQL_ENDPOINT) != null ? _ref : '/api/graphql/';
    if (!PUBLIC_GRAPHQL_ENDPOINT) {
        throw new Error('No public GraphQL endpoint found. Please set the NEXT_PUBLIC_GRAPHQL_ENDPOINT environment variable.');
    }
    // Parse the public GraphQL endpoint
    PUBLIC_GRAPHQL_ENDPOINT = new URL(PUBLIC_GRAPHQL_ENDPOINT, 'https://example.org/').pathname;
    // trim trailing slash
    PUBLIC_GRAPHQL_ENDPOINT = PUBLIC_GRAPHQL_ENDPOINT.replace(/\/$/, '');
    var _overrides_PUBLIC_DRAFT_MODE_ENDPOINT, _ref1;
    let PUBLIC_DRAFT_MODE_ENDPOINT = (_ref1 = (_overrides_PUBLIC_DRAFT_MODE_ENDPOINT = overrides.PUBLIC_DRAFT_MODE_ENDPOINT) != null ? _overrides_PUBLIC_DRAFT_MODE_ENDPOINT : process.env.NEXT_PUBLIC_DRAFT_MODE_ENDPOINT) != null ? _ref1 : '/api/draft/';
    if (!PUBLIC_DRAFT_MODE_ENDPOINT) {
        throw new Error('No public Draft Mode endpoint found. Please set the NEXT_PUBLIC_DRAFT_MODE_ENDPOINT environment variable.');
    }
    // Parse the public Draft Mode endpoint
    PUBLIC_DRAFT_MODE_ENDPOINT = new URL(PUBLIC_DRAFT_MODE_ENDPOINT, 'https://example.org/').pathname;
    // trim trailing slash
    PUBLIC_DRAFT_MODE_ENDPOINT = PUBLIC_DRAFT_MODE_ENDPOINT.replace(/\/$/, '');
    return {
        PUBLIC_DRAFT_MODE_ENDPOINT,
        PUBLIC_GRAPHQL_ENDPOINT
    };
}

module.exports = getClientConstants;
